<template>
  <div class="mx-3">
    <v-row>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in notification name here"
          append-icon="search"
          label="Search notification type"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="notificationTypes"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.name="{ item }">
        <div>
          <span>
            {{ item.name }}
          </span>
        </div>
      </template>
      <template v-slot:item.is_active="{ item }">
        <div>
          <v-icon 
            v-if="item.is_active === 1" 
            color="green"
          >
            mdi-check-outline
          </v-icon>
          <v-icon 
            v-else 
            color="error"
          >
            mdi-close-outline
          </v-icon>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <setup-notification-notification-type-dialog-edit
          v-if="$hasPermissionTo(['update notification types'])"
          :notification-type="item"
          @updated="loadData"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupNotificationNotificationTypeDialogEdit: () => import('@/components/hris/setup/notification/notification-type/DialogEdit'),
    },
    data () {
      return {
        headers: [
          {
            text: 'Notification Types',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Active',
            align: 'left',
            value: 'is_active',
          },
          {
            text: '',
            align: 'center',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: false,
        notificationTypes: [],
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.tableLoading = true
        
        this.$api.notificationTypes().list()
          .then(response => {
            this.notificationTypes = response.data

            this.tableLoading = false
          })
      },
    },
  }
</script>
